import { render } from "./DateField.vue?vue&type=template&id=2674b9fc&ts=true"
import script from "./DateField.vue?vue&type=script&lang=ts"
export * from "./DateField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__